import { Link, useNavigate } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from "../Footer/Footer";
import icon02 from "../../../screenassets/images/cta/02.png";
import { useState } from 'react';
import { ToastContainer, toast } from "react-toastify";


export default function Forgot() {


    const navigate = useNavigate();
    const [email, setEmail] = useState();

    const handleSubmit = async (event) => {
        if (event) event.preventDefault();
        // Regex for email validation
        const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!email) {
            toast.info("Please enter an email address!");
            return;
        }

        if (!re.test(email)) {
            toast.info("Please enter a valid email address!");
            return;
        }

        const resetData = {
            email: email
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/resetpassword`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(resetData),
            });
            const data = await response.json();

            if (data.status === true) {
                toast.success("OTP has been sent to your email!");
                navigate("../otpverify", { state: resetData });
            } else {
                toast.error("Invalid Email ID!");
                navigate("/Forgot");
            }

            setEmail("");

        } catch (error) {
           toast.error("Something went wrong! Please try again later.");
        }

    };


    return (
        <>
            {/* Header Section */}
            <Header />

            <div className="rts-bread-crumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb-inne">
                                <div className="title-area">
                                    <h1 className="bread-title">Reset Password</h1>
                                    <div className="inner-wrapper">
                                        <Link to="/">Home</Link>/
                                        <Link to="#" className="active">Reset Password</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            {/* Toast container */}
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

            {/* Form Section */}
            <div className="rts-reset-area rts-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="single-form-s-wrapper text-start ptb--120 ptb_sm--50">
                                <div className="head">
                                    <h5 className="title">Reset Your Password</h5>
                                    <p className="mb--20">
                                        Strong passwords include numbers, letters, and punctuation
                                        marks.
                                    </p>
                                </div>
                                <div className="body">
                                    <form onSubmit={(event) => { handleSubmit(event) }}>
                                        <div className="input-wrapper">
                                            <input type="email" id='email' name='email' value={email} onChange={(event) => { setEmail(event.target.value) }} placeholder="Email" required Style="border:none !important" />
                                        </div>
                                        {/* <div className="check-wrapper">
                                            <div className="form-check">
                                                <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault" required/>
                                                <label className="form-check-label" for="flexCheckDefault">
                                                    I agree to privacy policy & terms
                                                </label>
                                            </div>
                                        </div> */}
                                        <button type="submit" className="rts-btn btn-primary text-white">
                                            Send link
                                        </button>
                                        <p>
                                            <Link to="/signin"><i className="fa-solid fa-arrow-left"></i> Back to Login</Link>
                                        </p>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="rts-cta-area rts-section-gapBottom bg_faq">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="cta-main-wrapper bg_image">
                                <div className="left">
                                    <h3 className="title">
                                        All set to level up <br />
                                        your content game?
                                    </h3>
                                    <Link to="/about" className="rts-btn btn-primary">Get Started Now</Link>
                                </div>
                                <div className="right">
                                    <img src={icon02} alt="cta-area" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* Footer Section */}
            <Footer />

        </>
    )
}
